import React from 'react';
import './EmptyPlaceholder.less';

export const EmptyPlaceholder = ({text}) => {
	return <div className="empty-placeholder">{text}</div>
}
